export default class Chamada {
  constructor(titulo = '', inscricaoInicio = '', inscricaoFim = '') {
    this.titulo = titulo;
    this.inscricaoInicio =	inscricaoInicio;
    this.inscricaoFim = inscricaoFim;
  }
}
